import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Typography, makeStyles, Popup, PopupContent, Grid, TextField, MonthPicker, Divider, Select, } from "../../../index";
import { useTranslation } from "../../../hooks/useTranslation";
import { FilterCondition } from "../models/FilterCondition";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        margin: theme.spacing(0, 3, 0, 1),
        lineHeight: 0,
    },
    row: {
        margin: theme.spacing(1, 0),
    },
    filterAction: {
        margin: theme.spacing(0, 1),
    },
    filterButton: {},
}); });
/**
 * ノートのフィルターコンポーネント
 */
export var NoteSelectFilter = function (props) {
    var open = props.open, filterCondition = props.filterCondition, anchorEl = props.anchorEl, onFilterSelect = props.onFilterSelect, onFilterClear = props.onFilterClear, onCloseFilter = props.onCloseFilter;
    var _a = useState(''), title = _a[0], setTitle = _a[1];
    var _b = useState(null), createdFromMonth = _b[0], setCreatedFromMonth = _b[1];
    var _c = useState(null), createdToMonth = _c[0], setCreatedToMonth = _c[1];
    var _d = useState('ALL'), hasAssignment = _d[0], setHasAssignment = _d[1];
    var _e = useState(false), excludesHasAssignment = _e[0], setExcludesHasAssignment = _e[1];
    var t = useTranslation().t;
    var classes = useStyles();
    useEffect(function () {
        if (!open)
            return;
        setTitle(filterCondition.title);
        setCreatedFromMonth(filterCondition.createdFromMonth);
        setCreatedToMonth(filterCondition.createdToMonth);
        setHasAssignment(filterCondition.hasAssignment);
        setExcludesHasAssignment(filterCondition.excludesHasAssignment);
    }, [filterCondition, open]);
    var hasAssignmentValues = useMemo(function () {
        return [
            {
                label: t('全て'),
                value: 'ALL',
            },
            {
                label: t('設定されている'),
                value: 'TRUE',
            },
            {
                label: t('設定されていない'),
                value: 'FALSE',
            },
        ];
    }, [t]);
    var handleChangeTitle = useCallback(function (inputTitle) {
        setTitle(inputTitle);
    }, []);
    var handleChangeCreatedFromMonth = useCallback(function (inputCreatedFromMonth) {
        setCreatedFromMonth(inputCreatedFromMonth);
    }, []);
    var handleChangeCreatedToMonth = useCallback(function (inputCreatedToMonth) {
        setCreatedToMonth(inputCreatedToMonth);
    }, []);
    var handleChangeHasAssignment = useCallback(function (selectedValue) {
        setHasAssignment(selectedValue);
    }, []);
    var handleClose = useCallback(function () {
        onCloseFilter();
    }, [onCloseFilter]);
    var handleClickClear = useCallback(function () {
        onFilterClear();
    }, [onFilterClear]);
    var handleClickFilter = useCallback(function () {
        onFilterSelect(new FilterCondition({
            title: title,
            createdFromMonth: createdFromMonth,
            createdToMonth: createdToMonth,
            hasAssignment: hasAssignment,
            excludesHasAssignment: excludesHasAssignment,
        }));
    }, [onFilterSelect, title, createdFromMonth, createdToMonth, hasAssignment, excludesHasAssignment]);
    return (React.createElement("div", { className: classes.root },
        React.createElement(Popup, { open: open, anchorEl: anchorEl, width: 720, onClickAway: handleClose, placement: "bottom-end" },
            React.createElement(PopupContent, null,
                React.createElement(Grid, { container: true, alignItems: "center", className: classes.row },
                    React.createElement(Grid, { item: true, xs: 2 },
                        React.createElement(Typography, { variant: "body1" }, t('ノート名'))),
                    React.createElement(Grid, { item: true, xs: 10 },
                        React.createElement(TextField, { placeholder: t('ノート名を入力'), dense: true, value: title, onInput: handleChangeTitle, maxLength: 100 }))),
                React.createElement(Grid, { container: true, alignItems: "center", className: classes.row },
                    React.createElement(Grid, { item: true, xs: 2 },
                        React.createElement(Typography, { variant: "body1" }, t('作成月'))),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(MonthPicker, { value: createdFromMonth, onChange: handleChangeCreatedFromMonth, disableFuture: true })),
                    React.createElement(Grid, { item: true, xs: 1 },
                        React.createElement(Typography, { align: "center" }, t('から'))),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(MonthPicker, { value: createdToMonth, onChange: handleChangeCreatedToMonth, disableFuture: true })),
                    React.createElement(Grid, { item: true, xs: 1 },
                        React.createElement(Typography, { align: "center" }, t('まで')))),
                !excludesHasAssignment && (React.createElement(Grid, { container: true, alignItems: "center", className: classes.row },
                    React.createElement(Grid, { item: true, xs: 2 },
                        React.createElement(Typography, null, t('課題'))),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Select, { onChange: handleChangeHasAssignment, selectItems: hasAssignmentValues, value: hasAssignment, dense: true, width: 230 }))))),
            React.createElement(Divider, null),
            React.createElement(PopupContent, null,
                React.createElement(Grid, { container: true, justify: "flex-end" },
                    React.createElement(Button, { className: classes.filterAction, variant: "square", onClick: handleClickClear }, t('クリア')),
                    React.createElement(Button, { className: classes.filterAction, variant: "square", onClick: handleClickFilter, fill: true }, t('検索')))))));
};
